<template>
  <v-app id="app">
    <!-- Header -->
    <v-navigation-drawer v-model="drawer" right app disable-resize-watcher>
      <v-list dense>
        <v-list-item v-for="(link, index) in links" :key="'link-' + index" :to="link.href" link>
          <v-list-item-action>
            <v-icon>{{ link.icon }}</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ link.label }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item link @click="logout">
          <v-list-item-action>
            <v-icon>mdi-log-out</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Sign Out</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar color="primary" app dark absolute>
      <router-link to="/">
        <v-img :src="require('@/assets/mlp-logo-sm.png')" class="my-auto mr-3" max-width="40" max-height="40" contain></v-img>
      </router-link>
      <router-link to="/">
        <v-toolbar-title class="white--text" link href="/">My Life Pie</v-toolbar-title>
      </router-link>
      <v-spacer></v-spacer>
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
    </v-app-bar>

    <!-- Page Content -->
    <v-main>
      <router-view/>
    </v-main>
  </v-app>
</template>

<style>
.theme--light.v-application {
  background: #FFFFFF !important;
}
</style>

<script>
  import firebase from 'firebase';
  export default {
    data: () => ({
      drawer: false,

      links: [
        { href: '/',        label: 'Home',              icon: 'mdi-home' },
        { href: '/pre-quiz', label: 'Start New Pie',     icon: 'mdi-chart-pie' },
        { href: '#',        label: 'View Old Pies',     icon: 'mdi-database' },
        { href: '#',        label: 'Share Pie Results', icon: 'mdi-share-variant' }
      ],
    }),

    methods: {
      logout() {
        firebase
          .auth()
          .signOut()
          .then(() => {
            alert('Successfully logged out');
            window.location.reload();
          })
          .catch(error => {
            alert(error.message);
          });
      },
    }
  }
</script>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>